import { takeEvery,takeLatest, call, put } from 'redux-saga/effects';
import {
  setStateKey,
  fetchAffLink,
  authAff,
  fetchAffInfo,
  fetchAffiliateAddress,
  createViewAffiliate,
  updateTx
} from '../slices/affiliateSlice'
import {affiliateApi, authApi}  from '../../api/'
import { AffiliateType } from '../../models/affiliate.interface';


export function* onFetchAffLink() {
    try {
      const  res:any  =  yield call(affiliateApi.getKey)
    
      yield put(setStateKey({
        key : "link",
        value : res.referralKey
      }))

    }catch(ex){
       console.log(ex)
    } 
}


export function* onAuthAff(action) {

  try {
    const  res:any  =  yield call(authApi.auth ,action.payload )
  }catch(ex){
     console.log(ex)
  } 
}

export function* onfetchAffInfo() {

  try {
    const  info:AffiliateType  =  yield call(affiliateApi.getInfo)
    yield put(setStateKey({key:"info" ,value : info }))
  }catch(ex){
     console.log(ex)
  } 
}

export function* onfetchWalletAddressByRef(action: any) {
  try {
    const res: any = yield call(
      affiliateApi.getWalletAddress,
      action.payload.ref,
    )
    yield put(createViewAffiliate(action.payload))
    yield put(setStateKey({ key: 'address', value: res.walletAddress }))
  } catch (ex) {
    console.log(ex)
  }
}

//createView
export function* onCreateViewAffiliate(action: any) {
  try {
    const res: any = yield call(affiliateApi.createView, action.payload)
  } catch (ex) {
    console.log(ex)
  }
}

export function* onUpdateTx(action: any) {
  try {
    const res: any = yield call(affiliateApi.updateTx, action.payload)
    console.log(res)
  } catch (ex) {
    console.log(ex)
  }
}


// Individual exports for testing
export default function* watchSaga() {
  yield takeLatest(fetchAffLink.type, onFetchAffLink);
  yield takeLatest(authAff.type, onAuthAff);
  yield takeLatest(fetchAffInfo.type, onfetchAffInfo);
  yield takeLatest(fetchAffiliateAddress.type, onfetchWalletAddressByRef)
  yield takeLatest(createViewAffiliate.type, onCreateViewAffiliate)
  yield takeLatest(updateTx.type, onUpdateTx)
}